import React from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import HeroSection from '../components/HeroSection'
import BookingArea from '../components/BookingArea'
import FeatureArea from '../components/FeatureArea'
import AboutArea from '../components/AboutArea'
import CounterArea from '../components/CounterArea'
import FAQsArea from '../components/FAQsArea'
import BlogArea from '../components/BlogArea'
import DownloadArea from '../components/DownloadArea'

function HomePage() {
  return (
    <div className='home-3'>

        <Header/>

        <main>

            <HeroSection/>

            <BookingArea/>

            <FeatureArea/>

            <AboutArea/>

            <CounterArea/>

            <FAQsArea/>

            <BlogArea/>

            <DownloadArea/>

        </main>
        
        <Footer/>

    </div>
  )
}

export default HomePage